import React from 'react';
import { Names, Image, ImageWrapper, Quote, TextWrapper, Wrapper } from './Testimonial.styles';

export type TestimonialProps = {
  image: string;
  firstName: string;
  secondName?: string;
  quote: React.ReactElement | string;
};

const Testimonial: React.FC<TestimonialProps> = ({
  image,
  firstName,
  secondName,
  quote,
}): JSX.Element => {
  return (
    <Wrapper>
      <ImageWrapper>
        <Image src={image} alt="" loading="lazy" />
      </ImageWrapper>
      <TextWrapper>
        <Quote>&quot;{quote}&quot;</Quote>
        <Names>
          —{firstName}
          {secondName ? ` & ${secondName}` : null}
        </Names>
      </TextWrapper>
    </Wrapper>
  );
};

export default Testimonial;
